import { render } from "./NewRatingForm.vue?vue&type=template&id=237d872e&scoped=true"
import script from "./NewRatingForm.vue?vue&type=script&lang=js"
export * from "./NewRatingForm.vue?vue&type=script&lang=js"

import "./NewRatingForm.vue?vue&type=style&index=0&id=237d872e&scoped=true&lang=scss"

import exportComponent from "/Users/alexanderwesselburg/Projekte/MyPortal/fewo-in-ahrenshoop_v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237d872e"]])

export default __exports__